import { render, staticRenderFns } from "./shooterFrame.vue?vue&type=template&id=3c0462cf&scoped=true&"
import script from "./shooterFrame.vue?vue&type=script&lang=ts&"
export * from "./shooterFrame.vue?vue&type=script&lang=ts&"
import style0 from "./shooterFrame.vue?vue&type=style&index=0&id=3c0462cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0462cf",
  null
  
)

export default component.exports